import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded"
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded"
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded"
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded"
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded"
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded"
import { HIGHLIGHTS_SECTION, HIGHLIGHT_ITEMS } from "@/features/landing/content"

const icons = [
  <SettingsSuggestRoundedIcon />,
  <ConstructionRoundedIcon />,
  <ThumbUpAltRoundedIcon />,
  <AutoFixHighRoundedIcon />,
  <SupportAgentRoundedIcon />,
  <QueryStatsRoundedIcon />
]

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: "text.primary",
        bgcolor: "background.default"
      }}>
      <Container
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 }
        }}>
        <Box
          sx={{
            width: { sm: "100%", md: "60%" },
            textAlign: { sm: "left", md: "center" }
          }}>
          <Typography component="h2" variant="h4" gutterBottom>
            {HIGHLIGHTS_SECTION.heading}
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {HIGHLIGHTS_SECTION.body}
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {HIGHLIGHT_ITEMS.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: "inherit",
                  p: 3,
                  height: "100%",
                  borderColor: "divider",
                  backgroundColor: "background.paper"
                }}>
                <Box sx={{ opacity: "50%" }}>{icons[index % icons.length]}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: "medium" }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}
